"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var React = _interopRequireWildcard(require("react"));

var _invariant = _interopRequireDefault(require("invariant"));

var _warning = _interopRequireDefault(require("warning"));

var _isEmptyChildren = _interopRequireDefault(require("../_utils/isEmptyChildren"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _reactI18n = require("@insolus/react-i18n");

var _transitions = require("../_utils/transitions");

var Alert = function Alert(props) {
  var className = props.className,
      type = props.type,
      title = props.title,
      closable = props.closable,
      children = props.children,
      message = props.message,
      onClose = props.onClose,
      showIcon = props.showIcon;

  var _useTranslate = (0, _reactI18n.useTranslate)('ui-kit'),
      __ = _useTranslate.__;

  var _React$useState = React.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isClosed = _React$useState2[0],
      setClosed = _React$useState2[1];

  var handleClose = React.useCallback(function () {
    setClosed(true);
  }, []);
  var handleExit = React.useCallback(function ($$node) {
    $$node.style.height = "".concat($$node.offsetHeight, "px");
    (0, _transitions.triggerBrowserReflow)($$node);
  }, []);
  var handleExited = React.useCallback(function () {
    if (onClose) {
      onClose();
    }
  }, [onClose]);
  (0, _warning.default)(!(message && children && !(0, _isEmptyChildren.default)(children)), "Vous ne devriez pas utiliser la prop. `message` et sp\xE9cifier le message en tant " + "qu'enfant en m\xEAme temps sur une m\xEAme `<Alert>`, la prop. `message` va \xEAtre ignor\xE9e ");

  var _message = !Array.isArray(message) ? message : message.join('\n');

  if (children && !(0, _isEmptyChildren.default)(children)) {
    _message = children;
  }

  (0, _invariant.default)(_message, "Le component `<Alert>` n\xE9cessite que l'on sp\xE9cifie soit la prop. `message`, " + "soit la prop. `message`. aucune de ces deux props. n'a \xE9t\xE9 sp\xE9cifi\xE9e.");

  var _className = (0, _classnames.default)(className, 'Alert', "Alert--".concat(type), {
    'Alert--extended': !!title,
    'Alert--with-icon': showIcon
  });

  var closeButton = null;

  if (closable) {
    closeButton = React.createElement("button", {
      type: "button",
      className: "Alert__close",
      "aria-label": __('alert.close'),
      onClick: handleClose
    }, React.createElement(_Icon.default, {
      type: "close"
    }));
  }

  return React.createElement(_transitions.CSSTransition, {
    in: !isClosed,
    block: "Alert",
    enter: false,
    timeout: 300,
    onExit: handleExit,
    onExited: handleExited,
    unmountOnExit: true
  }, React.createElement("div", {
    className: _className,
    role: "alert"
  }, title && React.createElement("span", {
    className: "Alert__title"
  }, title), React.createElement("div", {
    className: "Alert__message"
  }, _message), closeButton));
};

Alert.defaultProps = {
  closable: false,
  showIcon: false,
  title: undefined,
  message: undefined,
  onClose: undefined,
  children: undefined,
  className: undefined
};
var _default = Alert;
exports.default = _default;